import { render, staticRenderFns } from "./kanban.vue?vue&type=template&id=6823a8c2&scoped=true&"
import script from "./kanban.vue?vue&type=script&lang=js&"
export * from "./kanban.vue?vue&type=script&lang=js&"
import style0 from "./kanban.vue?vue&type=style&index=0&id=6823a8c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6823a8c2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\桌面\\学习资料\\ZXX\\ZJPMWEB\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6823a8c2')) {
      api.createRecord('6823a8c2', component.options)
    } else {
      api.reload('6823a8c2', component.options)
    }
    module.hot.accept("./kanban.vue?vue&type=template&id=6823a8c2&scoped=true&", function () {
      api.rerender('6823a8c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/zxx/components/competition/kanban.vue"
export default component.exports